
type ComponentObject = Record<string, unknown>;

export function withSubComponents<TMain extends object, TSub extends ComponentObject>(
    mainComponent: TMain,
    subComponents: TSub
): TMain & TSub {
    for (const key of Object.keys(subComponents)) {
        (mainComponent as unknown as ComponentObject)[key] = subComponents[key];
    }

    return mainComponent as TMain & TSub;
}